import { render, staticRenderFns } from "./appsIcon.vue?vue&type=template&id=f12e1e68&"
import script from "./appsIcon.vue?vue&type=script&lang=js&"
export * from "./appsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports